import Input from '@components/Input';
import {
  mapLocaleCodeToCountry,
  mapLocaleCodeToPlate,
} from '@features/WordPress/utilities/helpers/locale';
import { useRouter } from 'next/router';
import classnames from 'classnames';
import { FormikProps } from 'formik';
import styles from './LicensePlateInput.module.css';
import { useTranslation } from 'next-i18next';
import { ChangeEvent } from 'react';
import LicensePlateAddon from './LicensePlateAddon/LicensePlateAddon';
const {
  Input: InputClass,
  LpInput,
  Label: LabelClass,
  LicensePlateDisclaimer,
} = styles;

interface LicensePlateInputProps {
  inputLabel?: string;
  formik: FormikProps<any>;
  whiteInput?: boolean;
  dispatchLicensePlate?: (licensePlate: string) => void;
  name?: string;
  isCampaign?: boolean;
  additionalTerms?: string;
  keepAsArray?: boolean;
}

const LicensePlateInput = ({
  inputLabel,
  formik,
  whiteInput,
  dispatchLicensePlate,
  name,
  isCampaign = false,
  additionalTerms,
  keepAsArray,
}: LicensePlateInputProps) => {
  const { locale } = useRouter();
  const { t } = useTranslation(['pip', 'common']);

  // Determine the value to display in the input field
  const licensePlateValue = keepAsArray
    ? Array.isArray(formik.values.licensePlate) && formik.values.licensePlate[0]
      ? formik.values.licensePlate[0]
      : ''
    : formik.values.licensePlate;

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const formattedValue = inputValue.replace(/\s/g, '').toUpperCase();

    const formattedLicensePlate = keepAsArray
      ? [formattedValue]
      : formattedValue;

    formik.setFieldValue('licensePlate', formattedLicensePlate, false);
    dispatchLicensePlate?.(inputValue);
  };

  // Determine the error to display
  const licensePlateError = keepAsArray
    ? Array.isArray(formik.errors.licensePlate) && formik.errors.licensePlate[0]
    : formik.errors.licensePlate;

  return (
    <div className={LpInput}>
      {inputLabel && (
        <label className={LabelClass} htmlFor={inputLabel}>
          {inputLabel}
        </label>
      )}

      {isCampaign && (
        <p className={LicensePlateDisclaimer}>{additionalTerms}</p>
      )}

      <Input
        name={name || 'licensePlate'}
        readableName={
          licensePlateValue.toUpperCase() || t('plate', { ns: 'common' })
        }
        value={licensePlateValue.toUpperCase()}
        addon={
          <LicensePlateAddon
            error={Boolean(
              typeof formik.errors.licensePlate === 'string' &&
                formik.touched.licensePlate &&
                formik.errors.licensePlate
            )}
          />
        }
        style={{
          display: 'block',
          ...(whiteInput && { backgroundColor: '#fff' }),
        }}
        type="text"
        placeholder={mapLocaleCodeToPlate(locale).placeholder}
        className={classnames(InputClass)}
        country={mapLocaleCodeToCountry(locale)}
        showValidIcon={formik.errors.licensePlate === undefined}
        onBlur={formik.handleBlur}
        error={
          licensePlateError &&
          formik.touched.licensePlate &&
          typeof licensePlateError === 'string'
        }
        errorMessage={licensePlateError || 'Error occurred'}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default LicensePlateInput;
